import React from "react"
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';
import { useSelector } from 'react-redux';

import UserIcon from 'static/images/user.svg';
import EquipmentIcon from 'static/images/equipment.svg';

import ActionButtons from './ActionButtons';
import RouteCardButton from './RouteCardButton';
import RouteInfo from './RouteInfo';

function Route({ route: routeView }) {
  const { route, primaryDriver, primaryEquipment } = routeView;

  const routeOnMap = useSelector(
    (state) => state.routeMonitor.routesOnMap.find((item) => item.id === route.id)
  );
  const routeIsFocusedOnMap = useSelector(
    (state) => state.routeMonitor.focusedRouteOnMap === route.id
  );


  const routeId = `filterItemContainer-${route.id}`;

  return (
    <div
      data-testid={`route-monitor-route-${route.id}`}
      id={routeId}
      className="routeMonitorRouteItem"
      data-focused={routeIsFocusedOnMap}
      data-selected={!!routeOnMap}
    >
      <Flex
        className='tagColor'
        style={{ backgroundColor: routeOnMap?.color }}
        shouldShow={!!routeOnMap}
      />
      <Flex className="route-container" flexDirection="column">
        <RouteInfo route={routeView} />
        <Flex className="route-more-info" justifyContent="space-between" alignItems="center">
          <Flex alignItems="center">
            <Flex gap={2}>
              <img src={UserIcon} alt="Driver Icon" />
              <Text className="clamp" size="xss">{primaryDriver?.key}</Text>
            </Flex>
            <Flex gap={2}>
              <img src={EquipmentIcon} alt="Equipment Icon" />
              <Text className="clamp" size="xss">{primaryEquipment?.key}</Text>
            </Flex>
          </Flex>
          <ActionButtons routeView={routeView} />
        </Flex>
      </Flex>
      <RouteCardButton routeView={routeView} />
    </div>
  );
}

Route.propTypes = {
  route: PropTypes.object.isRequired
};

export default Route;
